import PageTitle from "@/components/PageTitle";
import PageHeading from "@/components/PageHeading";

type ObjectHeadingWrapper = {
  title: string;
};

export const ObjectHeadingWrapper = ({ title }: ObjectHeadingWrapper) => {
  return (
    <>
      <PageTitle pattern={`/sections/:sectionId/change-requests`} title={`Jobs | ${title}`} />
    </>
  );
};

type Props = {
  title?: string;
};

export function JobsHeader({ title }: Props) {
  return (
    <div data-testid="person-details-header">
      <div>
        <PageHeading title={title || "Details"} />
      </div>
      <ObjectHeadingWrapper title={title || "Jobs"} />
    </div>
  );
}

JobsHeader.defaultProps = {
  backLink: { to: "/jobs" }
};
